import { v4 as uuidv4 } from "uuid";
import { isNullOrUndefined } from "../../../common/utils";
export default class ConditionNode {
  isKeyCondition = false;
  constructor(id, pathFromRoot, parentNode) {
    if (!isNullOrUndefined(id)) {
      this.key = id;
    } else {
      this.key = uuidv4();
    }
    this.pathFromRoot = pathFromRoot;
    this.parent = parentNode;
  }
}
